import { Component, effect, Input, OnInit, inject } from '@angular/core';
import { FilterInput } from '@it2go/data-grid';
import { TableColumn } from '../../../../shared/components/kit/table/table.types';
import { OrganizationGridItemObject } from '@it2go/types';
import { FilterBuilder } from '../../../helper/filter.builder';
import { UserEmploymentInfoStore } from './user-employment-info.store';
import { dateField } from '../../../../shared/components/kit/table/table.fields';
import { getEmploymentsFrag } from './user-employment-info.query';
import { CardComponent } from '../../../../../components/kit/card/card.component';
import { TableComponent } from '../../../../shared/components/kit/table/table.component';
import { AgePipe } from '../../../../shared/pipes/age.pipe';
import { PrimeTemplate } from '@openng/optimus-ui/api';

@Component({
    selector: 'app-user-employment-info',
    templateUrl: './user-employment-info.component.html',
    styleUrl: './user-employment-info.component.scss',
    providers: [UserEmploymentInfoStore],
    imports: [
        CardComponent,
        TableComponent,
        AgePipe,
        PrimeTemplate,
    ],
})
export class UserEmploymentInfoComponent implements OnInit {
    protected readonly store = inject(UserEmploymentInfoStore);

    @Input({ required: true }) userId!: string;

    protected additionalFilters: FilterInput[][] = [];

    protected columns: TableColumn[] = [
        {
            name: 'name',
        },
        dateField('earliestDate', false, false),
        {
            name: 'years',
            dataKey: 'earliestDate',
        },
    ];

    protected organizations: OrganizationGridItemObject[] = [];

    constructor() {
        const store = this.store;
        store.doOnActions(
            () => this.getEmployments(),
            'deleteEmployment', 'updateEmployment', 'createEmployment',
        );
        effect(() => {
            const serviceIds = this.store.employmentItems()?.map((item) => item.serviceId);
            if (serviceIds.length) {
                this.store.api.getServices(FilterBuilder.singlePage({ id: serviceIds }));
            }
        });
    }

    public async ngOnInit() {
        await this.getEmployments();
    }

    private getEmployments() {
        return this.store.api.getEmployments(FilterBuilder.singlePage({ userId: this.userId }), getEmploymentsFrag);
    }
}
